import { Box, Button, Checkbox, Dialog, DialogContent, FormControlLabel, Typography } from "@mui/material";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { adwRunQuery } from "../../dataWranglerSlice";
import { CancelOutlined } from "@mui/icons-material";
import { colours } from "../../../../StyleConstants";
import { useWizardQuery } from "../../../../api/dataWranglerApiSlice";
import { selectSelectedDatabase } from '../../../common/databaseSlice';

type Props = {
    open: boolean;
    close: (b: boolean) => void;
}

function RunQueryModal(props: Props) {
    const { open, close } = props;
    const [shadowMatrixIncluded, setShadowMatrixIncluded] = useState(false);

    const selectedDatabase = useSelector(selectSelectedDatabase);
    const { data: wizardData } = useWizardQuery({ database: selectedDatabase });
    const withShadowData = Object.keys(wizardData?.allInstruments || []).some((instrument: any) => wizardData?.allInstruments[instrument].shadowMatrix);

    const dispatch = useDispatch();

    const runQuery = () => {
        dispatch(adwRunQuery(shadowMatrixIncluded));
        close(false);
    }

    const closeModal = () => close(false);

    return (
        <Dialog open={open} onClose={closeModal}>
            <DialogContent sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Typography variant="h5" sx={{ fontWeight: 'bold' }}>
                    Download Data
                </Typography>
                <CancelOutlined sx={{ cursor: 'pointer' }} onClick={closeModal}/>
            </DialogContent>

            <DialogContent>
                {withShadowData ? <Box>
                    <FormControlLabel
                        control={
                            <Checkbox
                                sx={{
                                    color: colours.orange.orange,
                                    "&.Mui-checked": {
                                        color: colours.orange.orange,
                                    },
                                }}
                                checked={shadowMatrixIncluded}
                                onChange={() => setShadowMatrixIncluded(!shadowMatrixIncluded)}
                            />
                        }
                        label={
                            <Typography sx={{ fontSize: "12px", fontWeight: 600 }}>
                                    Include reason for missing data (in separate CSV)
                            </Typography>
                        }
                    />
                </Box> :
                    <Typography sx={{ fontWeight: 600, marginBottom: 2 }}>
                        Download ZIP file with results from the selected parameters.
                    </Typography>}
                <Box sx={{ display: 'flex', justifyContent: 'space-around' }}>
                    <Button variant="contained" onClick={closeModal}>Edit Query</Button>
                    <Button variant="primary" onClick={runQuery}>Run Query</Button>
                </Box>
            </DialogContent>
        </Dialog>
    )
}

export default RunQueryModal;